module.exports = __webpack_public_path__ + "static/media/1.466a0ea6.JPG";